export default "/assets/images/sock.ee849f6a740e1de5.png";